import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, startWith, Subscription } from 'rxjs';

export interface SessionData {
  Signature: string;
  UserIp: string;
  Domains: string;
  SessionId: string;
  Environment?: string;
  Username?: string;
  DomainPermissions?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private intervalSub: Subscription | null = null;
  private sessionDataSubject = new BehaviorSubject<SessionData | null>(null);
  sessionData$ = this.sessionDataSubject.asObservable();

  get sessionData() {
    return this.sessionDataSubject.value;
  }

  constructor() {
    this.setupHeaders();
  }

  public getHeaders() {
    window.postMessage({ type: 'GetInitialReportData' }, '*');
    window.addEventListener('message', this.listener);
  }

  private listener = (e: any) => {
    if (e.data?.type === 'SetInitialReportData') {
      window.removeEventListener('message', this.listener);
      const payload = e.data.payload;
      const newSessionData: SessionData = {
        Signature: payload.Signature,
        SessionId: payload.SessionId,
        UserIp: payload.UserIp,
        Domains: payload.Domains || '1000',
        Environment: payload.Environment,
        Username: payload.Username,
        DomainPermissions: payload.DomainPermissions,
      };

      this.sessionDataSubject.next(newSessionData);
    }
  };

  resetSession(): void {
    this.setInitData(null);
    this.setupHeaders();
  }

  setInitData(data: any): void {
    this.sessionDataSubject.next(data);
  }

  setupHeaders(): void {
    // 1200000 = 20min;
    this.intervalSub?.unsubscribe();
    this.intervalSub = interval(1200000)
      .pipe(startWith(0))
      .subscribe(() => this.getHeaders());
  }
}
